export const ERROR_BOUNDARY_NAME = 'customer-data-board-error';
export const DEFAULT_MAX_CARDS_PER_COLUMN = 100;
export const DEFAULT_CARDS_PER_PAGE = 25;